import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function DocumentsYouWillNeed() {
  return;
}